import React from "react";
import MDBox from "mui_components/MDBox";
import MDTypography from "mui_components/MDTypography";
import Chip from "@mui/material/Chip";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import { useDigitalPassController } from "context";

function LocationChipTitle() {
  const [controller] = useDigitalPassController();
  const { userDetails } = controller;

  // Only show for terminal port police users
  if (userDetails?.subType !== "terminal_port_police" || !userDetails?.assignedLocation) {
    return null;
  }

  return (
    <MDBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      mt={2}
      mb={2}
      px={2}
    >
      <Chip
        icon={<LocationOnIcon />}
        label={`Assigned Location: ${userDetails.assignedLocation}`}
        color="success"
        size="medium"
        sx={{
          fontSize: "0.875rem",
          fontWeight: "bold",
          width: "100%",
          height: "auto",
          py: 1,
          "& .MuiChip-label": {
            whiteSpace: "normal",
            textAlign: "center",
          },
        }}
      />
    </MDBox>
  );
}

export default LocationChipTitle;

